<template>
  <el-dialog :title="!dataForm.id ? 'Add User' : 'Edit User'" :close-on-click-modal="false" :visible.sync="visible" width="900px" top="3vh">
    <div v-loading="laoding">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="140px">
        <el-form-item label="Nickname" prop="nickname">
          <el-input v-model="dataForm.nickname" placeholder="Nick name" disabled></el-input>
        </el-form-item>
        <el-form-item label="Roles" size="mini" prop="roleIdList">
          <el-checkbox-group v-model="dataForm.roleIdList">
            <el-checkbox v-for="role in roleList" :key="role.id" :label="role.id">{{ role.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Supplier" prop="supplierIdList">
          <el-select v-model="dataForm.supplierIdList" filterable clearable multiple class="wdb100">
            <el-option v-for="item in allSupplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
          <div class="lh20 fs12 black88">When empty, default to having all supplier permissions</div>
        </el-form-item>
        <el-form-item label="Assign To" prop="replacementUser">
          <el-select v-model="dataForm.replacementUserId" filterable clearable class="wdb100" @change="replacementUserChange">
            <el-option v-for="item in sysUserList" :key="`sys-user-${item.id}`" :label="item.nickname" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Assign Supplier" prop="replacementUserSupplierIdList">
          <el-select v-model="dataForm.replacementUserSupplierIdList" filterable clearable multiple class="wdb100">
            <el-option v-for="item in allSupplierList" :key="`replacement-supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-loading="laoding" element-loading-custom-class="dialog-loading-hide">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit()">OK</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    allSupplierList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        nickname: "",
        roleIdList: [],
        supplierIdList: [],
        replacementUserId: null,
        replacementUserSupplierIdList: [],
      },
      dataRule: {
        nickname: [{ required: true, message: "please select", trigger: "submit" }],
        // supplierIdList: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
      },
      sysUserList: [],
      submitLoading: false,
      laoding: false,
    };
  },
  computed: {
    ...mapGetters("role", ["roleList"]),
  },
  methods: {
    // 初始化
    async init(data) {
      this.laoding = true;
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      await this.getSysUserList();
      if (data) {
        const roleIdList = data.roleList?.map(i => i.id) || [];
        const supplierIdList = data.supplierList?.map(j => j.id) || [];
        this.dataForm = {
          id: data.id,
          nickname: data.nickname,
          roleIdList,
          supplierIdList,
          replacementUserId: data.replacementUser?.id,
          replacementUserSupplierIdList: [],
        };
        this.replacementUserChange(data.replacementUser?.id);
      }
      this.laoding = false;
    },
    // 获取后台用户列表
    getSysUserList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/sysUser/getList")
          .then(res => {
            const resData = res.data || [];
            this.sysUserList = resData.filter(item => item.status == 1 && item.isAssistant == 1);
            resolve();
          })
          .catch(err => {
            this.sysUserList = [];
            // 不阻塞
            resolve();
          });
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(`/admin/sysUser/${this.dataForm.id}/update`, this.dataForm)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // Assign To 发生change时
    replacementUserChange(id) {
      const supplierList = this.sysUserList.find(item => item.id == id)?.supplierList || [];
      const idList = supplierList.map(ele => ele.id);
      this.$set(this.dataForm, "replacementUserSupplierIdList", idList);
    },
  },
};
</script>
